<script lang="ts">
import MarkdownIt from 'markdown-it';
import { legacyPipeTables } from './legacy-pipe-tables';

// 消息来自用户或服务端：禁用原始 HTML，保留解析器的链接协议校验。
const markdown = new MarkdownIt({ breaks: true, html: false, linkify: true }).use(legacyPipeTables);
markdown.renderer.rules.link_open = (tokens, index, options, _env, renderer) => {
  const token = tokens[index]!;
  token.attrSet('target', '_blank');
  token.attrSet('rel', 'noopener noreferrer');
  return renderer.renderToken(tokens, index, options);
};
markdown.renderer.rules.table_open = () => '<div class="markdown-message__table"><table>\n';
markdown.renderer.rules.table_close = () => '</table></div>\n';
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{ source: string; legacyTables?: boolean }>();
const html = computed(() => markdown.render(props.source, { legacyTables: props.legacyTables }).trimEnd());
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -- 原始 HTML 已禁用，链接协议由 markdown-it 校验 -->
  <div class="markdown-message widget-bubble__text" v-html="html"></div>
</template>

<style scoped>
.markdown-message {
  min-width: 0;
  color: var(--w-fg-body);
  font-size: 13px;
  line-height: 1.65;
  margin: 2px 0;
  overflow-wrap: anywhere;
}
.markdown-message :deep(p),
.markdown-message :deep(ul),
.markdown-message :deep(ol),
.markdown-message :deep(blockquote),
.markdown-message :deep(pre),
.markdown-message :deep(.markdown-message__table) { margin: 0 0 10px; }
.markdown-message :deep(ul) { list-style: disc; padding-left: 22px; }
.markdown-message :deep(ol) { list-style: decimal; padding-left: 22px; }
.markdown-message :deep(li + li) { margin-top: 4px; }
.markdown-message :deep(li > p) { margin-bottom: 4px; }
.markdown-message :deep(li > ul),
.markdown-message :deep(li > ol) { margin: 4px 0 0; }
.markdown-message :deep(h1),
.markdown-message :deep(h2),
.markdown-message :deep(h3),
.markdown-message :deep(h4),
.markdown-message :deep(h5),
.markdown-message :deep(h6) { font-size: 14px; line-height: 1.5; margin: 14px 0 6px; }
.markdown-message :deep(blockquote) { border-left: 3px solid var(--w-border-strong); padding-left: 10px; color: var(--w-fg-muted); }
.markdown-message :deep(a) { color: var(--w-primary-hover); text-decoration: underline; text-underline-offset: 2px; }
.markdown-message :deep(code) { background: var(--w-surface); border-radius: 3px; padding: 2px 4px; font-size: 12px; }
.markdown-message :deep(pre) { overflow-x: auto; background: var(--w-surface); border-radius: 5px; padding: 10px; white-space: pre; overflow-wrap: normal; }
.markdown-message :deep(pre code) { background: transparent; padding: 0; }
.markdown-message :deep(.markdown-message__table) { overflow-x: auto; }
.markdown-message :deep(table) { width: 100%; border-collapse: collapse; }
.markdown-message :deep(th),
.markdown-message :deep(td) { border: 1px solid var(--w-border-strong); padding: 6px 8px; min-width: 5em; text-align: left; overflow-wrap: normal; }
.markdown-message :deep(th) { background: var(--w-surface); }
.markdown-message :deep(img) { max-width: 100%; height: auto; }
.markdown-message :deep(hr) { border: 0; border-top: 1px solid var(--w-border-strong); margin: 10px 0; }
.markdown-message :deep(> :first-child) { margin-top: 0; }
.markdown-message :deep(> :last-child) { margin-bottom: 0; }
</style>
